export default {
    customer_order: $localize `Customer order ads`,
    partner_order: $localize `Partner order ads`,
    product_placement: $localize `Product placement`,
}